/**
 * lucide dropped its brand marks, so LinkedIn's is drawn here in lucide's own
 * grid and stroke, and takes the same `svg.lucide` sizing as every other icon.
 */
export function LinkedinIcon(): React.JSX.Element {
  return (
    <svg
      className="lucide"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect width="4" height="12" x="2" y="9" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  );
}
